import { Outlet, Navigate } from 'react-router-dom'
import { localStorageService } from '../services/localStorage'
const PublicRoute = () => {
  // const isAuth = false
  return !localStorageService.isAuth() ? <Outlet /> : <Navigate to='/' />
}

export default PublicRoute
